document.addEventListener('DOMContentLoaded', function() {
  // Ensure the function is available in the global scope
  window.submitGoogleReview = async function() {
    const googleReviewSection = document.getElementById('google-review-section');
    const customerId = googleReviewSection.getAttribute('data-customer-id');
    const hoverContent = googleReviewSection.querySelector('.hover-content');

    console.log('Submitting Google Review for Customer ID:', customerId);

    // Show loading message
    hoverContent.innerHTML = '<div class="status-completed"><span class="check-icon">&#10003;</span> Czekaj...</div>';

    try {
      // Call Cloud Function to submit Google review points
      const response = await fetch('https://us-central1-la-roue-53165.cloudfunctions.net/googleReview', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ customerId: customerId, points: 50 })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();

      if (result.success) {
        // Open Google review page in a new tab
        window.open('https://search.google.com/local/writereview?placeid=ChIJe8uZn5DNHkcRURKiT0eoksk', '_blank');

        // Update the Google Review metafield to mark as completed
        await fetch('/updateCustomerMetafield', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            customerId: customerId,
            metafield: {
              namespace: 'custom',
              key: 'google_review',
              value: 'completed',
              type: 'single_line_text_field'
            }
          })
        });

        // Update UI to completed state with success message
        hoverContent.innerHTML = '<div class="status-completed"><span class="check-icon">&#10003;</span> Dziękujemy za opinię</div>';
        // Update the data attribute to reflect the completed status
        googleReviewSection.setAttribute('data-google-review-status', 'completed');
      } else {
        throw new Error('Failed to submit Google review');
      }
    } catch (error) {
      console.error('Error:', error);
      // Show error message
      hoverContent.innerHTML = '<button class="rate-us-button" onclick="submitGoogleReview()">Oceń nas</button>';
      alert('Error: ' + error.message);
    }
  };
});
